import {LANGUAGE} from '@/common/utils/constants';

export const MANAGEMENT_LABELS = {
	[LANGUAGE.en.short]: {
		search: "Search",
		placeholder: "Search by id, type, label or created by",
		forApproval: "Pending",
		inactive: "Inactive",
		approved: "Approved",
		projectId: "Project IDs",
		noProjects: "No projects assigned",
		createdDate: "Date Created"
	},
	[LANGUAGE.de.short]: {
		search: "Suchen",
		placeholder: "Suchen Sie nach ID, Typ, Label oder erstellt von",
		forApproval: "Zur Genehmigung",
		inactive: "Inaktiv",
		approved: "Genehmigt",
		projectId: "Projekt-IDs",
		noProjects: "Keine Projekte zugewiesen",
		createdDate: "Erstellungsdatum"
	},
	[LANGUAGE.fr.short]: {
		search: "Recherche",
		placeholder: "Recherche par identifiant, type, étiquette ou créé par",
		forApproval: "En attente d'approbation",
		inactive: "Inactif",
		approved: "Approuvé",
		projectId: "ID de projet",
		noProjects: "Aucun projet assigné",
		createdDate: "Date de création"
	},
	[LANGUAGE.it.short]: {
		search: "Ricerca",
		placeholder: "Cerca per ID, tipo, etichetta o creato da",
		forApproval: "In attesa di approvazione",
		inactive: "Inattivo",
		approved: "Approvato",
		projectId: "ID progetto",
		noProjects: "Nessun progetto assegnato",
		createdDate: "Data di creazione"
	},
	[LANGUAGE.ja.short]: {
		search: "検索",
		placeholder: "ID、タイプ、ラベル、または作成者による検索",
		forApproval: "承認待ち",
		inactive: "非アクティブ",
		approved: "承認された",
		projectId: "プロジェクトID",
		noProjects: "プロジェクトが割り当てられていません",
		createdDate: "作成日"
	},
	[LANGUAGE.es.short]: {
		search: "Buscar",
		placeholder: "Buscar por ID, tipo, etiqueta o creado por",
		forApproval: "Pendiente de aprobación",
		inactive: "Inactivo",
		approved: "Aprobado",
		projectId: "IDs de proyecto",
		noProjects: "No hay proyectos asignados",
		createdDate: "Fecha de creación"
	}
}
